export default __webpack_public_path__ + "static/media/fauna-mobile-ia.361e4050.png";